<div #container [attr.id]="'cont'+modelId" class="con">
  <canvas class="canvas" #canvas [attr.id]="'can'+modelId"></canvas>
  <app-context-menu [items]="contextMenuItems"></app-context-menu>
</div>